import {NotificationsActionTypeKeys, NotificationsActionTypes} from "../actions/notificationsActionTypes";
import initialState from "./notificationsInitialState";

export default (
  state = initialState,
  action: NotificationsActionTypes
) => {
  switch (action.type) {
    case NotificationsActionTypeKeys.ADD_NOTIFICATION:
      return { ...state, notifications: [action.notification] };
    case NotificationsActionTypeKeys.CLEAR_NOTIFICATIONS:
      return { ...state, notifications: [] };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.ts